<template>
  <div class="hourly-stats">
    <v-chart ref="chart" autoresize theme="light" :options="chart"/>
    <div class="hourly-stats__controls">
      <sw-button
        class="hourly-stats__control"
        v-model="parameters.rangeMode"
        :label="$t('component.chart.rangeMode')"
      ></sw-button>
      <div v-if="!parameters.rangeMode">
        <min-sel v-model="parameters.hours" @input="hoursChange">
          <option :value="72">3 {{ $t('component.chart.days') }}</option>
          <option :value="168">7 {{ $t('component.chart.days') }}</option>
          <option :value="336">2 {{ $t('component.chart.weeks') }}</option>
          <option :value="744">1 {{ $t('component.chart.month') }}</option>
          <option :value="1488">2 {{ $t('component.chart.months') }}</option>
          <option :value="2232">3 {{ $t('component.chart.months') }}</option>
        </min-sel>
      </div>
      <div class="hourly-stats__range" v-else>
        <in
          type="date"
          @input="rangeInput"
          class="hourly-stats__control"
          v-model="parameters.rangeStart"
          :label="$t('component.chart.rangeStart')"
        ></in>
        <in
          type="date"
          @input="rangeInput"
          class="hourly-stats__control"
          v-model="parameters.rangeStop"
          :label="$t('component.chart.rangeStop')"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      parameters: {
        hours: 72,
        rangeMode: false,
        rangeStart: null,
        rangeStop: null
      },
      chart: {
        title: {
          text: this.$t('view.dashboard.hoursMessagesChart')
        },
        textStyle: {
          fontFamily: 'lato'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [this.$t('component.chart.sent'), this.$t('component.chart.received'), this.$t('component.chart.total')]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['stack', 'tiled'], title: { stack: this.$t('component.chart.stack'), tiled: this.$t('component.chart.tiled') } },
            saveAsImage: { show: true, title: this.$t('component.chart.saveAsImage') }
          }
        },
        xAxis: {
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: this.$t('component.chart.sent'),
          type: 'line',
          data: [],
          color: '#dd7373'
        },
        {
          name: this.$t('component.chart.received'),
          type: 'line',
          data: [],
          color: '#007cbe'
        },
        {
          name: this.$t('component.chart.total'),
          type: 'line',
          data: [],
          color: '#ffd23f'
        }]
      }
    }
  },
  methods: {
    loadDataToChart(data) {
      const h1 = 60 * 60 * 1000
      let dates = []
      let sent = []
      let received = []
      let total = []
      let lastPushedDate = 0;

      for (let i = 0; i < data.length; i++) {
        while (i && +new Date(data[i].date) - lastPushedDate > h1) {
          const d = new Date(lastPushedDate + h1)
          dates.push(this.formDate(d, true))
          sent.push(0)
          received.push(0)
          total.push(0)
          lastPushedDate = +new Date(lastPushedDate + h1)
        }

        const d = new Date(data[i].date)
        dates.push(this.formDate(d, true))
        sent.push(data[i].messenger_messages_outcoming + data[i].webchat_messages_outcoming)
        received.push(data[i].messenger_messages_incoming + data[i].webchat_messages_incoming)
        total.push(data[i].messenger_messages_outcoming + data[i].messenger_messages_incoming + data[i].webchat_messages_outcoming + data[i].webchat_messages_incoming)
        lastPushedDate = +new Date(data[i].date)
      }

      this.chart.xAxis.data = dates
      this.chart.series[0].data = sent
      this.chart.series[1].data = received
      this.chart.series[2].data = total
    },

    async hoursChange(v) {
      try {
        const dataReq = await axios.get(`/api/stats/hourly?hours=${v}`)
        this.loadDataToChart(dataReq.data.rows)
      } catch (e) {
        console.error(e)
      }
    },

    async rangeInput() {
      try {
        const start = this.parameters.rangeStart
        const stop = this.parameters.rangeStop
        if (!start || !stop) return
        const dataReq = await axios.get(`/api/stats/hourly-range?start=${start}&stop=${stop}`)
        this.loadDataToChart(dataReq.data.rows)
      } catch (e) {
        console.error(e)
      }
    }
  },
  async created() {
    try {
      const rowsReq = await axios.get('/api/stats/hourly?hours=72')
      this.loadDataToChart(rowsReq.data.rows)
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.hourly-stats {
  @include flowElementShadow();
  background-color: white;
  margin-top: 11px;
  padding: 15px;
  border-radius: 4px;

  &__controls {
    @include alignedFlex(flex-start);
    @include standarizeStatControls();
  }

  &__control {
    margin-right: 20px;
  }

  &__range {
    @include alignedFlex(flex-start);
  }
}
</style>
